import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { MenuItem } from '@material-ui/core';

import { Select, LoadingIndicator } from '../../../components';
import FilterWrapper from '../filter-wrapper';

class ReportsFilter extends Component {
  handleSelectReport = (reportId) => {
    const { selectedReport, selectReport, removeReportData } = this.props;

    if (selectedReport && reportId !== selectedReport.reportID) {
      removeReportData(0);
      selectReport(reportId);
    }
  }

  renderReportSelect = () => {
    const { reports, selectedReport } = this.props;


    const areReportsAvailable = reports.length > 0;

    const reportItems = areReportsAvailable ? reports.map(r => (
      <MenuItem value={r.reportID} key={r.reportID}>{r.name}</MenuItem>
    )) : <MenuItem value="">Kein Bericht verfügbar</MenuItem>;

    return (
      <div>
        <h3>Reports</h3>
        <Select
          disabled={!areReportsAvailable}
          placeholder="Report"
          value={selectedReport ? selectedReport.reportID : ''}
          onChange={event => this.handleSelectReport(event.target.value)}
        >
          {reportItems}
        </Select>
      </div>
    );
  }

  render() {
    const { isAdvancedFilter, filterWrapperStyle, isLoading } = this.props;

    return (
      <FilterWrapper isAdvancedFilter={isAdvancedFilter} style={filterWrapperStyle}>
        {isLoading
          ? (
            <div style={{ textAlign: 'center' }}><LoadingIndicator /></div>
          )
          : this.renderReportSelect()
    }
      </FilterWrapper>
    );
  }
}

ReportsFilter.propTypes = {
  isAdvancedFilter: PropTypes.bool,
  reports: PropTypes.array.isRequired,
  selectedReport: PropTypes.object,
  filterWrapperStyle: PropTypes.object,
  isLoading: PropTypes.bool,
  selectReport: PropTypes.func.isRequired,
  removeReportData: PropTypes.func.isRequired,
};

ReportsFilter.defaultProps = {
  isAdvancedFilter: false,
  selectedReport: null,
  filterWrapperStyle: null,
  isLoading: false,
};

export default ReportsFilter;
